<div class="not-found">
  <div class="not-found__content">
    <div class="not-found__icon">
      <kendo-svg-icon [icon]="errorIcon" class="not-found__icon-svg"></kendo-svg-icon>
    </div>

    <h1 class="not-found__title">404</h1>
    <h2 class="not-found__subtitle">Page Not Found</h2>
    <p class="not-found__message">
      The page you are looking for might have been removed, had its name changed, or is temporarily
      unavailable.
    </p>

    <div class="not-found__actions">
      <app-primary-button (click)="goHome()">
        <kendo-svg-icon [icon]="homeIcon" class="not-found__button-icon"></kendo-svg-icon>
        Go to Home
      </app-primary-button>
      <app-secondary-button (click)="goBack()">Go Back</app-secondary-button>
    </div>
  </div>
</div>
